import React, { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function CreateDataSourceFromWizardRawFiles(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [databaseName, setDatabaseName] = useState('')
    const [dataSourceName, setDataSourceName] = useState('')
    const [jobFiles, setJobFiles] = useState([])
    const [individualFiles, setIndividualFiles] = useState([])
    const [selectedJobFileId, setSelectedJobFileId] = useState('')
    const [selectedJobFile, setSelectedJobFile] = useState('')
    const [filesWithinZip, setFilesWithinZip] = useState([])
    const [wizardFile, setWizardFile] = useState('')
    const [sourceFiles, setSourceFiles] = useState([])
    const [idSourceFiles, setIdSourceFiles] = useState([])
    const [sqLDbList, setSqLDbList] = useState([])
    const [textQualifier, setTextQualifier] = useState(-1)
    const [textDelimiter, setTextDelimiter] = useState(0)
    const [customDelimiter, setCustomDelimiter] = useState('')
    const [availableExcelTables, setAvailableExcelTables] = useState([])
    const [usingFlatFiles, setUsingFlatFiles] = useState(false)
    const [usingExcel, setUsingExcel] = useState(false)
    const [selectedExcelTables, setSelectedExcelTables] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setDataSourceName(props.taskData.dataSourceName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceName('')
        }

        if ((props.taskData.wizardTextQualifier && props.taskData.wizardTextQualifier > -1) || (props.taskData.wizardTextQualifier === 0)) {
            setTextQualifier(props.taskData.wizardTextQualifier)
        }

        if (props.jobFiles && props.jobFiles.length > 0) {
            setJobFiles(props.jobFiles)
            filterAndSetIndividualFiles(props.jobFiles)
            setSelectedJobFileId(props.taskData.selectedZipFileId)
            setSelectedJobFile(props.taskData.selectedZipFile)
            zipFileSelectedWithFilesWithZipFileIdLookup(props.taskData.selectedZipFile, props.taskData.selectedZipFileId, props.jobFiles)
            setWizardFile(props.taskData.wizardFile)
            wizardFileSelectedWithFiles(props.taskData.wizardFile)

            if (props.taskData.selectedZipFileId.trim().length > 0) {
                const soloZipFiles = processFilesWithinZipSolo(props.taskData.sourceFiles)
                const mainSourceFiles = processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles)
                if (filesHereAreGuids(soloZipFiles)) {
                    setIdSourceFiles(mainSourceFiles)
                } else {
                    setIdSourceFiles(soloZipFiles)
                }
            } else {
                setIdSourceFiles(processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles))
            }

            setSourceFiles(props.taskData.sourceFiles)
        }

        let delim = 0
        let customDelim = ""
        let allExcelTables = []
        if (props.taskData.delimiter != null && props.taskData.delimiter != undefined && props.taskData.delimiter > -1) {
            delim = props.taskData.delimiter
            setTextDelimiter(delim)
        }
        if (props.taskData.wizardTextQualifier != null && props.taskData.wizardTextQualifier != undefined && props.taskData.wizardTextQualifier > -1) {
            setUsingFlatFiles(true)
            setUsingExcel(false)
        }
        if (props.taskData.customDelimiter) {
            customDelim = props.taskData.customDelimiter
            setCustomDelimiter(customDelim)
            setUsingFlatFiles(true)
            setUsingExcel(false)
        }
        if (props.taskData.excelDataTables && props.taskData.excelDataTables.length > 0) {
            allExcelTables = props.taskData.excelDataTables
            setUsingExcel(true)
            setUsingFlatFiles(false)
            setAvailableExcelTables(allExcelTables)
            setSelectedExcelTables(allExcelTables)
        } else {
            setAvailableExcelTables([])
            setSelectedExcelTables([])
            setUsingExcel(false)
        }
        if (props.taskData.sourceFiles.length > 0) {
            if (checkSourceFilesIfWeUsingExcel(props.taskData.sourceFiles, props.jobFiles)) {
                setUsingExcel(true)
                setUsingFlatFiles(false)
            } else {
                setUsingExcel(false)
                setUsingFlatFiles(true)
            }
        } else {
            setUsingExcel(false)
            setUsingFlatFiles(false)
        }
        fireOnSaveEvent(props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceName, props.taskData.selectedZipFileId, props.taskData.selectedZipFile, props.taskData.wizardFile, props.taskData.wizardTextQualifier, props.taskData.sourceFiles, delim, customDelim, allExcelTables)
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setDataSourceName(props.taskData.dataSourceName)

            let delim = 0
            let customDelim = ""
            let allExcelTables = []
            if (props.taskData.textDelimiter) {
                delim = props.taskData.textDelimiter
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.customDelimiter) {
                customDelim = props.taskData.customDelimiter
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.excelDataTables && props.taskData.excelDataTables.length > 0) {
                allExcelTables = props.taskData.excelDataTables
                setUsingExcel(true)
                setUsingFlatFiles(false)
                setAvailableExcelTables(allExcelTables)
                setSelectedExcelTables(allExcelTables)
            } else {
                setAvailableExcelTables([])
                setSelectedExcelTables([])
                setUsingExcel(false)
            }
            if (props.taskData.sourceFiles.length > 0) {
                if (checkSourceFilesIfWeUsingExcel(props.taskData.sourceFiles, props.jobFiles)) {
                    setUsingExcel(true)
                    setUsingFlatFiles(false)
                } else {
                    setUsingExcel(false)
                    setUsingFlatFiles(true)
                }
            } else {
                setUsingExcel(false)
                setUsingFlatFiles(false)
            }
            fireOnSaveEvent(props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceName, props.taskData.selectedZipFileId, props.taskData.selectedZipFile, props.taskData.wizardFile, props.taskData.wizardTextQualifier, props.taskData.sourceFiles, delim, customDelim, allExcelTables)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceName('')
        }
    }, [props.taskData.databaseId])

    useEffect(() => {
        if (!arraysAreEqual(props.taskData.sourceFiles, sourceFiles)) {
            if (props.taskData.databaseId !== -1) {
                setDatabaseId(props.taskData.databaseId)
                setDatabaseName(props.taskData.databaseName)
                setDataSourceName(props.taskData.dataSourceName)
            }

            if ((props.taskData.wizardTextQualifier && props.taskData.wizardTextQualifier > -1) || (props.taskData.wizardTextQualifier === 0)) {
                setTextQualifier(props.taskData.wizardTextQualifier)
            }

            if (props.jobFiles && props.jobFiles.length > 0) {
                setJobFiles(props.jobFiles)
                filterAndSetIndividualFiles(props.jobFiles)
                setSelectedJobFileId(props.taskData.selectedZipFileId)
                setSelectedJobFile(props.taskData.selectedZipFile)
                zipFileSelectedWithFilesWithZipFileIdLookup(props.taskData.selectedZipFile, props.taskData.selectedZipFileId, props.jobFiles)
                setWizardFile(props.taskData.wizardFile)
                wizardFileSelectedWithFiles(props.taskData.wizardFile)

                if (props.taskData.selectedZipFileId.trim().length > 0) {
                    const soloZipFiles = processFilesWithinZipSolo(props.taskData.sourceFiles)
                    const mainSourceFiles = processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles)
                    if (filesHereAreGuids(soloZipFiles)) {
                        setIdSourceFiles(mainSourceFiles)
                    } else {
                        setIdSourceFiles(soloZipFiles)
                    }
                } else {
                    setIdSourceFiles(processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles))
                }

                setSourceFiles(props.taskData.sourceFiles)
            }

            let delim = 0
            let customDelim = ""
            let allExcelTables = []
            if (props.taskData.delimiter != null && props.taskData.delimiter != undefined && props.taskData.delimiter > -1) {
                delim = props.taskData.delimiter
                setTextDelimiter(delim)
            }
            if (props.taskData.wizardTextQualifier != null && props.taskData.wizardTextQualifier != undefined && props.taskData.wizardTextQualifier > -1) {
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.customDelimiter) {
                customDelim = props.taskData.customDelimiter
                setCustomDelimiter(customDelim)
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.excelDataTables && props.taskData.excelDataTables.length > 0) {
                allExcelTables = props.taskData.excelDataTables
                setUsingExcel(true)
                setUsingFlatFiles(false)
                getExcelTablesFromFilesFromLoad(props.taskData.sourceFiles.concat(props.taskData.selectedZipFileId),props.jobFiles,allExcelTables)
            } else {
                setAvailableExcelTables([])
                setSelectedExcelTables([])
                setUsingExcel(false)
            }
            if (props.taskData.sourceFiles.length > 0) {
                if (checkSourceFilesIfWeUsingExcel(props.taskData.sourceFiles, props.jobFiles)) {
                    setUsingExcel(true)
                    setUsingFlatFiles(false)
                } else {
                    setUsingExcel(false)
                    setUsingFlatFiles(true)
                }
            } else {
                setUsingExcel(false)
                setUsingFlatFiles(false)
            }
            fireOnSaveEvent(props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceName, props.taskData.selectedZipFileId, props.taskData.selectedZipFile, props.taskData.wizardFile, props.taskData.wizardTextQualifier, props.taskData.sourceFiles, delim, customDelim, allExcelTables)
        }
    }, [props.taskData.sourceFiles])

    useEffect(() => {
        if (!arraysAreEqual(props.taskData.excelDataTables, selectedExcelTables)) {
            if (props.taskData.databaseId !== -1) {
                setDatabaseId(props.taskData.databaseId)
                setDatabaseName(props.taskData.databaseName)
                setDataSourceName(props.taskData.dataSourceName)
            }

            if ((props.taskData.wizardTextQualifier && props.taskData.wizardTextQualifier > -1) || (props.taskData.wizardTextQualifier === 0)) {
                setTextQualifier(props.taskData.wizardTextQualifier)
            }

            if (props.jobFiles && props.jobFiles.length > 0) {
                setJobFiles(props.jobFiles)
                filterAndSetIndividualFiles(props.jobFiles)
                setSelectedJobFileId(props.taskData.selectedZipFileId)
                setSelectedJobFile(props.taskData.selectedZipFile)
                zipFileSelectedWithFilesWithZipFileIdLookup(props.taskData.selectedZipFile, props.taskData.selectedZipFileId, props.jobFiles)
                setWizardFile(props.taskData.wizardFile)
                wizardFileSelectedWithFiles(props.taskData.wizardFile)

                if (props.taskData.selectedZipFileId.trim().length > 0) {
                    const soloZipFiles = processFilesWithinZipSolo(props.taskData.sourceFiles)
                    const mainSourceFiles = processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles)
                    if (filesHereAreGuids(soloZipFiles)) {
                        setIdSourceFiles(mainSourceFiles)
                    } else {
                        setIdSourceFiles(soloZipFiles)
                    }
                } else {
                    setIdSourceFiles(processFilesWithinZip(props.taskData.sourceFiles, props.jobFiles))
                }

                setSourceFiles(props.taskData.sourceFiles)
            }

            let delim = 0
            let customDelim = ""
            let allExcelTables = []
            if (props.taskData.delimiter != null && props.taskData.delimiter != undefined && props.taskData.delimiter > -1) {
                delim = props.taskData.delimiter
                setTextDelimiter(delim)
            }
            if (props.taskData.wizardTextQualifier != null && props.taskData.wizardTextQualifier != undefined && props.taskData.wizardTextQualifier > -1) {
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.customDelimiter) {
                customDelim = props.taskData.customDelimiter
                setCustomDelimiter(customDelim)
                setUsingFlatFiles(true)
                setUsingExcel(false)
            }
            if (props.taskData.excelDataTables && props.taskData.excelDataTables.length > 0) {
                allExcelTables = props.taskData.excelDataTables
                setUsingExcel(true)
                setUsingFlatFiles(false)
                setAvailableExcelTables(allExcelTables)
                setSelectedExcelTables(allExcelTables)
            } else {
                setAvailableExcelTables([])
                setSelectedExcelTables([])
                setUsingExcel(false)
            }
            if (props.taskData.sourceFiles.length > 0) {
                if (checkSourceFilesIfWeUsingExcel(props.taskData.sourceFiles, props.jobFiles)) {
                    setUsingExcel(true)
                    setUsingFlatFiles(false)
                } else {
                    setUsingExcel(false)
                    setUsingFlatFiles(true)
                }
            } else {
                setUsingExcel(false)
                setUsingFlatFiles(false)
            }
            fireOnSaveEvent(props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceName, props.taskData.selectedZipFileId, props.taskData.selectedZipFile, props.taskData.wizardFile, props.taskData.wizardTextQualifier, props.taskData.sourceFiles, delim, customDelim, allExcelTables)
        }
    }, [props.taskData.excelDataTables])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDatabaseName('')

        let dbName = ""
        sqLDbList.forEach(db => {
            if (db.id === event.target.value) {
                setDatabaseName(db.dBname)
                dbName = db.dBname
            }
        })

        fireOnSaveEvent(event.target.value, dbName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, sourceFiles, textDelimiter, customDelimiter, selectedExcelTables)
    }

    function handleWizardFileChange(event) {
        event.preventDefault()
        zipFileSelected(event.target.value)
    }

    function zipFileSelected(zipFileName) {
        setIsLoadingRequest(false)
        setUsingFlatFiles(false)
        setUsingExcel(false)
        setSelectedJobFileId(zipFileName)
        setWizardFile('')
        setSelectedExcelTables([])
        setSourceFiles([])
        setIdSourceFiles([])

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["identifier"] === zipFileName) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(processFilesWithinZipSolo(lookup["zipIndividualFiles"]))
            fireOnSaveEvent(databaseId, databaseName, dataSourceName, zipFileName, lookup["name"], "", 0, [], textDelimiter, customDelimiter, selectedExcelTables)
        } else {
            setSelectedJobFileId('')
            setSelectedJobFile('')
            setFilesWithinZip([])
            setWizardFile('')
        }
    }

    function zipFileSelectedWithFiles(zipFileName, files) {
        setIsLoadingRequest(false)
        setSelectedJobFile(zipFileName)
        setWizardFile('')

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["name"] === zipFileName) {
                lookup = files[x]
            }
        }
        
        if (lookup) {
            setFilesWithinZip(processFilesWithinZipSolo(lookup["zipIndividualFiles"]))
        } else {
            setSelectedJobFile('')
            setFilesWithinZip([])
            setWizardFile('')
        }
    }

    function zipFileSelectedWithFilesWithZipFileIdLookup(zipFileName, fileId, files) {
        setIsLoadingRequest(false)
        setSelectedJobFile(zipFileName)
        setWizardFile('')

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["name"] === zipFileName) {
                lookup = files[x]
            }
        }

        if (!lookup) {
            for (let x = 0; x < files.length; x++) {
                if (files[x]["identifier"] === fileId) {
                    lookup = files[x]
                }
            }
        }
        
        if (lookup) {
            setFilesWithinZip(processFilesWithinZipSolo(lookup["zipIndividualFiles"]))
        } else {
            setSelectedJobFile('')
            setFilesWithinZip([])
            setWizardFile('')
        }
    }

    function handleFileWithinZipChange(event) {
        event.preventDefault()
        setIsLoadingRequest(false)
        wizardFileSelected(event.target.value)
    }

    function wizardFileSelected(fileWithinZipName) {
        setIsLoadingRequest(false)
        setWizardFile(fileWithinZipName)
        fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, fileWithinZipName, textQualifier, sourceFiles, textDelimiter, customDelimiter, selectedExcelTables)
    }

    function wizardFileSelectedWithFiles(fileWithinZipName) {
        setIsLoadingRequest(false)
        setWizardFile(fileWithinZipName)
    }

    function getExcelTablesFromFiles(fileNames) {
        let fileBlobs = []

        for (let x = 0; x < fileNames.length; x++) {
            let lookup = null
            for (let x = 0; x < jobFiles.length; x++) {
                if (jobFiles[x]["name"] === selectedJobFile) {
                    lookup = jobFiles[x]
                }
            }

            if (!lookup) {
                for (let z = 0; z < jobFiles.length; z++) {
                    for (let y = 0; y < fileNames.length; y++) {
                        if (jobFiles[z]["identifier"] === fileNames[y]) {
                            lookup = jobFiles[z]
                        }
                    }
                }
            }

            if (lookup) {
                fileBlobs.push({
                    name: lookup["name"],
                    url: lookup["url"],
                    containerName: lookup["containerName"],
                    blobName: lookup["blobName"],
                    selectedFileName: fileNames[x],
                    identifier: lookup["identifier"]
                })
            }

            if (fileBlobs.length > 0 && fileBlobs.filter(f => f.identifier === fileNames[x]).length === 0) {
                const fileLookup = jobFiles.filter(b => b.identifier === fileNames[x])
                for (let y = 0; y < fileLookup.length; y++) {
                    fileBlobs.push({
                        name: fileLookup[y]["name"],
                        url: fileLookup[y]["url"],
                        containerName: fileLookup[y]["containerName"],
                        blobName: fileLookup[y]["blobName"],
                        selectedFileName: fileNames[x],
                        identifier: fileLookup[y]["identifier"]
                    })
                }
            }
        }

        if (fileBlobs.length > 0) {
            setIsLoadingRequest(true)
            let getExcelTablesReq = props.readTablesFromExcelFiles(fileBlobs)
            getExcelTablesReq.then((resp) => {
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setAvailableExcelTables(json)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
            })
        } else {
            setIsLoadingRequest(false)
            setAvailableExcelTables([])
        }
    }

    function getExcelTablesFromFilesFromLoad(fileNames,fileFromProps,allExcelTables) {
        let fileBlobs = []

        for (let x = 0; x < fileNames.length; x++) {
            let lookup = null
            for (let z = 0; z < fileFromProps.length; z++) {
                for (let y = 0; y < fileNames.length; y++) {
                    if (fileFromProps[z]["identifier"] === fileNames[y]) {
                        lookup = fileFromProps[z]
                    }
                }
            }

            if (lookup) {
                fileBlobs.push({
                    name: lookup["name"],
                    url: lookup["url"],
                    containerName: lookup["containerName"],
                    blobName: lookup["blobName"],
                    selectedFileName: fileNames[x],
                    identifier: lookup["identifier"]
                })
            }

            if (fileBlobs.length > 0 && fileBlobs.filter(f => f.identifier === fileNames[x]).length === 0) {
                const fileLookup = fileFromProps.filter(b => b.identifier === fileNames[x])
                for (let y = 0; y < fileLookup.length; y++) {
                    fileBlobs.push({
                        name: fileLookup[y]["name"],
                        url: fileLookup[y]["url"],
                        containerName: fileLookup[y]["containerName"],
                        blobName: fileLookup[y]["blobName"],
                        selectedFileName: fileNames[x],
                        identifier: fileLookup[y]["identifier"]
                    })
                }
            }
        }

        if (fileBlobs.length > 0) {
            setIsLoadingRequest(true)
            let getExcelTablesReq = props.readTablesFromExcelFiles(fileBlobs)
            getExcelTablesReq.then((resp) => {
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setAvailableExcelTables(json)

                const crossover = allExcelTables.filter(item => json.includes(item))
                setSelectedExcelTables(crossover)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
            })
        } else {
            setIsLoadingRequest(false)
            setAvailableExcelTables([])
        }
    }

    function arraysAreEqual(arr1, arr2) {
        // Check if arrays have the same length
        if (arr1.length !== arr2.length) {
            return false;
        }

        // Check if each element in the arrays is identical
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        // If both conditions pass, arrays are equal
        return true;
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {Array} jobFilesFromProps - All of the job files we got from Props
     */
    function filterAndSetIndividualFiles(jobFilesFromProps) {
        let processedArray = []

        for (let x = 0; x < jobFilesFromProps.length; x++) {
            if (!jobFilesFromProps[x]["name"].toLowerCase().includes(".zip")) {
                processedArray.push({ "id": jobFilesFromProps[x]["identifier"], "name": jobFilesFromProps[x]["name"] })
            }
        }

        setIndividualFiles(processedArray)
    }


    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsName - Data source name
     * @param {string} zipFileId - Selected zip file unique ID
     * @param {string} zipFileName - Selected zip file for the current job
     * @param {string} selectedWizardFile - Wizard file within the zip file (Usually expecting this to be a JSON file)
     * @param {string} textQualifier - Text qualifier to be used on the flat files
     * @param {string[]} selectedSourceFiles - One or more flat files
     * @param {int} delimiter - Delimiter ID
     * @param {string} userDefiniedDelimiter - Custom Delimiter
     * @param {string[]} excelTables - All Selected Excel Tables
     */
    function fireOnSaveEvent(dbId, dbName, dsName, zipFileId, zipFileName, selectedWizardFile, textQualifier, selectedSourceFiles, delimiter, userDefiniedDelimiter, excelTables) {
        if (props.onSave) {
            let copiedTextQualifier = textQualifier
            if (copiedTextQualifier === -1) { copiedTextQualifier = 0 }

            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceName"] = dsName
            copied["selectedZipFileId"] = zipFileId
            copied["selectedZipFile"] = zipFileName
            copied["wizardFile"] = selectedWizardFile
            copied["wizardTextQualifier"] = copiedTextQualifier
            copied["sourceFiles"] = selectedSourceFiles
            copied["delimiter"] = delimiter
            copied["customDelimiter"] = userDefiniedDelimiter
            copied["excelDataTables"] = excelTables
            props.onSave(copied)
        }
    }

    function renderCustomDelimArea(delimType) {
        if (delimType === 4) {
            return <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Custom Delimiter"
                    variant="outlined"
                    value={customDelimiter}
                    disabled={isLoadingRequest}
                    onChange={(e) => {
                        e.preventDefault()
                        setCustomDelimiter(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, sourceFiles, textDelimiter, e.target.value, selectedExcelTables)
                    }} />
            </FormControl>
        }

        return null
    }

    /**
     * If flat files, render this area, otherwise, it'll render [renderExcelTableArea()]
     */
    function renderTextFileInfoArea() {
        if (usingFlatFiles) {
            return (<>
                <FormControl className="field" fullWidth>
                    <InputLabel id="text-delimiter-label">Choose File Delimiter</InputLabel>
                    <Select
                        labelId="text-delimiter-label"
                        id="text-delimiter"
                        label="Choose File Delimiter"
                        onChange={(e) => {
                            e.preventDefault()
                            setTextDelimiter(e.target.value)
                            fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, sourceFiles, e.target.value, customDelimiter, selectedExcelTables)
                        }}
                        value={textDelimiter}
                        defaultValue={0}
                        required
                        fullWidth
                        disabled={isLoadingRequest}>
                        <MenuItem value={0}>Comma</MenuItem>
                        <MenuItem value={1}>Tab</MenuItem>
                        <MenuItem value={2}>Space</MenuItem>
                        <MenuItem value={3}>Semicolon</MenuItem>
                        <MenuItem value={4}>Custom</MenuItem>
                    </Select>
                </FormControl>
                {renderCustomDelimArea(textDelimiter)}
                <FormControl className="field" fullWidth>
                    <InputLabel id="text-qualifier-label">Choose Text Qualifier</InputLabel>
                    <Select
                        labelId="text-qualifier-label"
                        id="text-qualifier"
                        label="Choose Text Qualifier"
                        onChange={(e) => {
                            e.preventDefault()
                            setTextQualifier(e.target.value)
                            fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, e.target.value, sourceFiles, textDelimiter, customDelimiter, selectedExcelTables)
                        }}
                        value={textQualifier}
                        defaultValue={-1}
                        required
                        fullWidth
                        disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Choose Text Qualifier</MenuItem>
                        <MenuItem value={0}>None</MenuItem>
                        <MenuItem value={1}>Single Quote</MenuItem>
                        <MenuItem value={2}>Double Quote</MenuItem>
                    </Select>
                </FormControl>
            </>)
        }

        return null
    }

    /**
     * Reads the state variables to determine if we need to render the excel drop down
     */
    function renderExcelMultipleTableAreas() {
        if (usingExcel) {
            return (<FormControl className="field" fullWidth>
                <Autocomplete
                    multiple
                    id="excel-sheets-standard"
                    options={availableExcelTables}
                    getOptionLabel={(option) => option}
                    value={selectedExcelTables}
                    disabled={isLoadingRequest}
                    onChange={(event, newValue) => {
                        setSelectedExcelTables([...newValue])
                        fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, sourceFiles, textDelimiter, customDelimiter, newValue)
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            label="Sheets From Excel"
                            placeholder="Sheets From Excel"
                        />
                    )} />
            </FormControl>)
        }

        return null
    }

    function processFilesWithinZipSolo(zippedFiles) {
        let rtnVal = []

        for (let x = 0; x < zippedFiles.length; x++) {
            rtnVal.push({ "id": zippedFiles[x], "name": zippedFiles[x] })
        }

        return rtnVal
    }

    function filesHereAreGuids(fileArray) {
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        for (let x = 0; x < fileArray.length; x++) {
            const name = fileArray[x]["name"]
            const isGuid = guidRegex.test(name)
            if (isGuid) {
                return true
            }
        }

        return false
    }

    function processFilesWithinZip(zippedFiles, jobFiles) {
        let rtnVal = []

        for (let y = 0; y < jobFiles.length; y++) {
            for (let x = 0; x < zippedFiles.length; x++) {
                if (jobFiles[y]["identifier"] === zippedFiles[x]) {
                    rtnVal.push({ "id": jobFiles[y]["identifier"], "name": jobFiles[y]["name"] })
                }
                if (jobFiles[y]["name"] === zippedFiles[x]) {
                    rtnVal.push({ "id": jobFiles[y]["identifier"], "name": jobFiles[y]["name"] })
                }
            }
        }

        return rtnVal
    }

    function checkSourceFilesIfWeUsingExcel(files, jobFiles) {
        let filesByIdentifier = jobFiles.filter(f => files.includes(f.identifier))
        let fileNames = []
        for (let fileItr = 0; fileItr < files.length; fileItr++) {
            fileNames.push(files[fileItr])
        }
        for (let fileItr = 0; fileItr < filesByIdentifier.length; fileItr++) {
            fileNames.push(filesByIdentifier[fileItr]["name"])
        }

        for (let fileItr = 0; fileItr < fileNames.length; fileItr++) {
            if (fileNames[fileItr].toLowerCase().includes(".xlsx") || fileNames[fileItr].toLowerCase().includes(".xls")) {
                return true
            }
        }

        return false
    }

    function toNormalCase(str) {
        // Replace hyphens with whitespace
        let stringWithSpaces = str.replace(/-/g, ' ')

        // Convert each word to normal case
        return stringWithSpaces.replace(/\b\w/g, function (char) {
            return char.toUpperCase()
        })
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Import Data Source From Raw Files</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                    <MenuItem value={-1}>Select Database</MenuItem>
                    {sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Data Source Name"
                    variant="outlined"
                    value={dataSourceName}
                    disabled={isLoadingRequest}
                    onChange={(e) => {
                        e.preventDefault()
                        setDataSourceName(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, e.target.value, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, sourceFiles, textDelimiter, customDelimiter, selectedExcelTables)
                    }} />
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-zip-file-label">Select Zip File</InputLabel>
                <Select
                    labelId="select-zip-file-label"
                    id="select-zip-file"
                    label="Select Zip File"
                    onChange={handleWizardFileChange}
                    value={selectedJobFileId}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Zip File</MenuItem>
                    {jobFiles.map((x) => x && x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-json-file-label">Select Wizard File</InputLabel>
                <Select
                    labelId="select-json-file-label"
                    id="select-json-file"
                    label="Select Wizard File"
                    onChange={handleFileWithinZipChange}
                    value={wizardFile}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Wizard File</MenuItem>
                    {filesWithinZip.map((x) => x && (x.name.toLowerCase().includes(".xpi") || x.name.toLowerCase().includes(".json")) && <MenuItem key={x.id} value={x.id}>[{selectedJobFile}]{x.name}</MenuItem>)}
                    {jobFiles.map((x) => x && !x.name.toLowerCase().includes(".zip") && (x.name.toLowerCase().includes(".xpi") || x.name.toLowerCase().includes(".json")) && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <Autocomplete
                    multiple
                    id="source-files-standard"
                    options={filesWithinZip.concat(individualFiles)}
                    getOptionLabel={(option) => option.name}
                    value={idSourceFiles}
                    disabled={isLoadingRequest}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, newValue) => {
                        let isThereAnyExcelFiles = false
                        let isThereAnyFlatFiles = false
                        let fileNames = []

                        for (let fileItr = 0; fileItr < newValue.length; fileItr++) {
                            if (newValue[fileItr]["name"].toLowerCase().includes(".xlsx") || newValue[fileItr]["name"].toLowerCase().includes(".xls")) {
                                isThereAnyExcelFiles = true
                                fileNames.push(newValue[fileItr]["id"])
                            } else {
                                isThereAnyFlatFiles = true
                            }
                        }

                        if (isThereAnyExcelFiles && isThereAnyFlatFiles) {
                            setUsingExcel(false)
                            setUsingFlatFiles(false)
                            setSourceFiles([])
                            setIdSourceFiles([])
                            fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, [], textDelimiter, customDelimiter, selectedExcelTables)
                        } else {
                            setUsingExcel(isThereAnyExcelFiles)
                            setUsingFlatFiles(isThereAnyFlatFiles)

                            // Read the excel file (assume its the very first file for now), get the list of tabs associated with the file
                            if (newValue.length > 0 && isThereAnyExcelFiles) {
                                getExcelTablesFromFiles(fileNames)
                            }

                            let processedSourceFiles = []
                            for (let x = 0; x < newValue.length; x++) {
                                processedSourceFiles.push(newValue[x]["id"])
                            }
                            setSourceFiles([
                                ...processedSourceFiles,
                            ])
                            setIdSourceFiles([
                                ...newValue
                            ])
                            fireOnSaveEvent(databaseId, databaseName, dataSourceName, selectedJobFileId, selectedJobFile, wizardFile, textQualifier, processedSourceFiles, textDelimiter, customDelimiter, selectedExcelTables)
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            label="Source Files"
                            placeholder="Source Files"
                        />
                    )} />
            </FormControl>
            {renderTextFileInfoArea()}
            {renderExcelMultipleTableAreas()}
        </Paper>)
}

export default CreateDataSourceFromWizardRawFiles